import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";

export const CAR_RUNNER_SCORE_API_RESOURCE = "car-runner-score" as const;
const CAR_RUNNER_LEADERBOARD_API_OPERATION = "leaderboard" as const;
const CAR_RUNNER_LEADERBOARD_API_PATH =
  `/v1/${CAR_RUNNER_SCORE_API_RESOURCE}/${CAR_RUNNER_LEADERBOARD_API_OPERATION}` as const;

export const CAR_RUNNER_LEADERBOARD_QUERY_KEY = [
  CAR_RUNNER_SCORE_API_RESOURCE,
  CAR_RUNNER_LEADERBOARD_API_OPERATION,
] as const;

export type CarRunnerLeaderboardResponse =
  paths[typeof CAR_RUNNER_LEADERBOARD_API_PATH]["get"]["responses"][200]["content"]["application/json"];

export function useCarRunnerLeaderboardQuery() {
  return useQuery({
    queryKey: CAR_RUNNER_LEADERBOARD_QUERY_KEY,
    queryFn: async () => {
      const response = await alphartisApiAxios.get<CarRunnerLeaderboardResponse>(CAR_RUNNER_LEADERBOARD_API_PATH);
      return response.data;
    },
  });
}
